export default "__VITE_ASSET__DTlbY68e__"